import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CategoryFilter from "../../components/CategoryFilter/CategoryFilter";
import CategoryTable from "../../components/CategoryTable/CategoryTable";
import ExpenseForm from "../../components/ExpenseForm/ExpenseForm";
import TransactionData from "../../components/TransactionData/TransactionData";
import style from "./Transaction.module.css"
const Transaction = () => {
  const navigate = useNavigate();
  const formData = useSelector((state) => state.user);
  return (
    <>
      <div className={style.transactionHeading}>
        <h1>{formData.userName}'s Monthly Expenditure</h1>
        <button id="new-update" onClick={() => navigate(-1)}>New/Update Tracker</button>
      </div>
      <CategoryTable />
      <ExpenseForm/>
      <CategoryFilter/>
      <TransactionData/>
    </>
  );
};

export default Transaction;
